import React from 'react';
import PropTypes from 'prop-types';
import { CaretDown } from '@phosphor-icons/react';
import './sandbox.css';

/** A show/hide button for the region `controls` names (Home's details and processes); the caret turns when open. */
export default function Disclosure({ open, onToggle, controls, children }) {
  return (
    <button aria-controls={controls} aria-expanded={open} className="sbx-disclosure" onClick={onToggle} type="button">
      {children}
      <CaretDown aria-hidden="true" className={`sbx-disclosure-caret${open ? ' open' : ''}`} size={14} />
    </button>
  );
}

Disclosure.propTypes = {
  open: PropTypes.bool.isRequired,
  onToggle: PropTypes.func.isRequired,
  controls: PropTypes.string.isRequired,
  children: PropTypes.node.isRequired,
};
